import { Buffer } from 'buffer';

import { API_ENDPOINT_PAYMENTS_SERVICE_2C2P } from '../config/api';
import { PAYMENT_GATEWAY } from '../constants';
import type { Environment, UseCase } from '../entities/enums';
import { PaymentDefaultError } from '../usecases/Errors/customErrors';

import { containsQueryString, generateQueryStrings } from './url';

const getReturnUrl = (
  paymentGateway: keyof typeof PAYMENT_GATEWAY,
  redirectQueryStrings: Array<{
    key: string;
    value: string;
  }>,
  _: UseCase,
  env?: Environment,
) => {
  const currentUrl = window.location.href;
  const returnUrl = containsQueryString(currentUrl)
    ? `${window.location.href}&`
    : `${window.location.href}?`;

  const returnUrlWithQueryString = `${returnUrl}${generateQueryStrings(
    redirectQueryStrings,
  )}`;

  if (paymentGateway === PAYMENT_GATEWAY.stripe) {
    return returnUrlWithQueryString;
  }

  if (paymentGateway === PAYMENT_GATEWAY['2c2p']) {
    if (!env) {
      throw new PaymentDefaultError('No environment provided');
    }

    const encodedUrl = Buffer.from(returnUrlWithQueryString).toString('base64');
    const returnUrlWithEncodedUrl = `${API_ENDPOINT_PAYMENTS_SERVICE_2C2P[env]}redirect?url=${encodedUrl}`;
    return returnUrlWithEncodedUrl;
  }

  throw new PaymentDefaultError('Unknown payment gateway');
};

export default getReturnUrl;
